import { useEffect } from 'react'
import useSWR from 'swr'
import { mutateAnalyticsData } from 'utils/analytics'
import { authFetcher } from 'utils/auth/authFetcher'
import { AUTH_KEY } from 'utils/auth/cache'

export const useAuth = () => {
  const { data: auth, error, mutate } = useSWR(AUTH_KEY, authFetcher)

  const isAuthLoading = !auth && !error
  const isLogged = auth?.isLogged === true

  useEffect(() => {
    if (isAuthLoading) return

    mutateAnalyticsData({
      loginState: isLogged ? 'logged_in' : 'not_logged_in',
    })
  }, [isAuthLoading, isLogged])

  return { isLogged, isAuthLoading, mutateAuth: mutate }
}
